export default "__VITE_ASSET__BUMVRpjg__"